import React from "react";

export default function IDELayout({ children }) {
  return (
    <div
      style={{
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#000"
      }}
    >
      {children}
    </div>
  );
}